// extracted by mini-css-extract-plugin
export var messageSideLeft = "_p6-1";
export var messageSideRight = "_p6-2";
export var orderLookupBubbleContainer = "_p6-0";
export var submitButton = "_p6-3";